import { CmcWebApi } from '@cmctechnology/webinvest-api-client-web-trading';
import { frontendActions } from '@cmctechnology/webinvest-store-frontend';
import { Dispatch } from '@reduxjs/toolkit';
import { ApiRequest } from './models/apiRequest';
import { actions, CLIENT_STORE_NAME } from './store';

export const fetchStockQueries = (includeGlobal: boolean = false) => {
  return async (dispatch: Dispatch<any>) => {
    const request: CmcWebApi.MarketInformation.StockFilterQueriesRequest1 = {
      IncludingGlobalQueries: includeGlobal
    };

    try {
      const response = await frontendActions.webTradingApiCall<CmcWebApi.MarketInformation.StockFilterQueriesModel2>(
        CLIENT_STORE_NAME,
        ApiRequest.StockFilterQueriesGet2,
        request,
        dispatch
      );
      dispatch<any>(actions.stockQueriesFetched(response));
    } catch {}
  };
};

export const fetchRecentStocks = () => {
  return async (dispatch: Dispatch<any>) => {
    try {
      const response = await frontendActions.webTradingApiCall<CmcWebApi.RecentStocksGet2Handler.RecentStocksGet2Model>(
        CLIENT_STORE_NAME,
        ApiRequest.RecentStocksGet2,
        {},
        dispatch
      );
      dispatch<any>(actions.recentStocksFetched(response));
    } catch {}
  };
};
